export enum HostedInfra {
    AZURE = "Azure",
    GCP = "GCP",
    ETHOS = "Ethos",
    ONPREM = "On-prem",
    AWS = "Aws"
}

export enum InstanceType {
    CONTAINER = "Container",
    VM = "VM"
}

export enum DatabaseType {
    MYSQL = 'MYSQL',
    ORACLE = 'ORACLE',
    POSTGRESQL = 'POSTGRESQL',
    AMAZON_AURORA = 'AMAZON AURORA',
    IBM_DB2 = 'IBM DB2',
    MARIA_DB = 'MARIA DB',

    LabelOnly = '',

    Mongo_DB = 'Mongo DB',
    Document_DB = 'Document DB',
    Cassandra_DB = 'Cassandra DB',
    Amazon_DynamoDB = 'Amazon DynamoDB',
}

export enum RelationalDB {
    MYSQL = 'MYSQL',
    ORACLE = 'ORACLE',
    POSTGRESQL = 'POSTGRESQL',
    AMAZON_AURORA = 'AMAZON AURORA',
    IBM_DB2 = 'IBM DB2',
    MARIA_DB = 'MARIA DB',
    OTHERS = 'OTHERS'
}

export enum NonRelationalDB {
    Mongo_DB = 'Mongo DB',
    Document_DB = 'Document DB',
    Cassandra_DB = 'Cassandra DB',
    Amazon_DynamoDB = 'Amazon DynamoDB',
    OTHERS = 'OTHERS'
}

export enum ExternalComponentType {
    REDIS = 'REDIS',
    ELASTIC_SEARCH = 'ELASTIC_SEARCH',
    SQS = 'SQS',
    OTHERS = 'OTHERS'
}

export enum ChaosActions {
    NEW = "NEW",
    UPDATE = "UPDATE",
    READ = "READ",
    DELETE = "DELETE",
    EMAIL = "EMAIL"
}

export enum ChaosModules {
    CHAOS_META_DATA = "CHAOS_META_DATA",
    CHAOS_PROJECT_INFRA = "CHAOS_PROJECT_INFRA",
    USE_CASES = "USE_CASES",
    NOTIFY = "NOTIFY",
    DOWNLOAD = "DOWNLOAD",
    RUN_BOOK = "RUN BOOK",
}